"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get down () {
        return down;
    },
    get up () {
        return up;
    }
});
const _globals = require("~/utils/globals");
const up = async (knex)=>{
    await knex.schema.alterTable(_globals.MetaTable.COL_RELATIONS, (table)=>{
        table.string('fk_related_base_id', 20);
        table.string('fk_mm_base_id', 20);
        table.string('fk_related_source_id', 20);
        table.string('fk_mm_source_id', 20);
    });
};
const down = async (knex)=>{
    await knex.schema.alterTable(_globals.MetaTable.COL_RELATIONS, (table)=>{
        table.dropColumn('fk_related_base_id');
        table.dropColumn('fk_mm_base_id');
        table.dropColumn('fk_related_source_id');
        table.dropColumn('fk_mm_source_id');
    });
};
